function hideShowHoldsSelection() {
  
  if($("#SingleOptionSelector-0").val().includes("No")) {
  	$('#murus-holds').hide();
  } else {
  	$('#murus-holds').show();
  }
}

$("#SingleOptionSelector-0").change(function() {
  hideShowHoldsSelection();
});

$('#AddToCart-product-murus-template').click(function() {
  if($("#SingleOptionSelector-0").val().includes("No")) {
    console.log("clearing quantities.");
    $("[id*='Quantity-']").val("0");
  } 
});

hideShowHoldsSelection();

/*
  Allow product to be added to cart via ajax with
  custom success and error responses.
*/
window.AjaxHoldsCart = (function() {
  var cart = function($form) {
    this.cache = {
      $cartIconIndicator: $('.site-header__cart-indicator')
    };

    this.$form = $form;
    this.eventListeners();
    console.log("Inited AjaxHoldsCart.");
  };

  cart.prototype.eventListeners = function() {
    if (this.$form.length) {
      this.$form.off( 'submit' );
      this.$form.on('submit', $.proxy(this.addItemFromForm, this));
    }
  };

  cart.prototype.getDataInArrayFormat = function() {
    var D = [];
    var data = {};

    this.$form.serializeArray().map(function(x) {

      data[x.name] = x.value;

      if (x.name == "quantity") {
          D.push(data);
          data = {};

      }

    });
    
    return {items: D}; 
  }
  
  cart.prototype.addItemFromForm = function(evt) {
    evt.preventDefault();

    var params = {
      type: 'POST',
      url: '/cart/add.js',
      data: this.getDataInArrayFormat(),
      dataType: 'json',
      success: $.proxy(function(lineItem) {
        this.success(lineItem);
      }, this),
      error: $.proxy(function(XMLHttpRequest, textStatus) {
        this.error(XMLHttpRequest, textStatus);
      }, this)
    };
	console.log(params.data);
    $.ajax(params);
    //console.log("Added item from cw...js");
    
    //jQuery.post('/cart/add.js', {items: params.data});
  };

  cart.prototype.success = function() {
    theme.Notify.open('success', false, true);

    // Update cart notification bubble's state
    this.cache.$cartIconIndicator.removeClass('hide');
  };

  // Error handling reference from Shopify.onError in api.jquery.js
  cart.prototype.error = function(XMLHttpRequest) {
    var data = JSON.parse(XMLHttpRequest.responseText);
    var message;
    if (data.message) {
      message = this.parseErrors(data).join('; ') + '.';
    } else {
      message = data.description;
    }
    theme.Notify.open('error', message, true);
  };

  // Error parsing from Shopify.fullMessagesFromErrors in api.jquery.js
  cart.prototype.parseErrors = function(errors) {
    var fullMessages = [];
    $.each(errors, function(attribute, messages) {
      $.each(messages, function(index, message) {
        fullMessages.push(attribute + ' ' + message);
      });
    });
    return fullMessages;
  };

  return cart;
})();

theme.AjaxHoldsCart = new window.AjaxHoldsCart($('#AddHoldsToCartForm'));